__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "veUtilities";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@design-systems/canvas-ui", "8.1.6", () => (Promise.all([__webpack_require__.e(2665), __webpack_require__.e(1347), __webpack_require__.e(6621), __webpack_require__.e(2175), __webpack_require__.e(3905)]).then(() => (() => (__webpack_require__(51347))))));
			register("@design-systems/react-icons", "1.1.5", () => (__webpack_require__.e(5376).then(() => (() => (__webpack_require__(65376))))));
			register("@design-systems/react-icons", "1.1.6", () => (__webpack_require__.e(5571).then(() => (() => (__webpack_require__(25571))))));
			register("lodash", "4.18.1", () => (() => (__webpack_require__(42894))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(28108))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(66685))), 1);
			initExternal(15918);
			initExternal(39794);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};